import { useRef, DependencyList } from 'react'

import useAsyncEffect from '../use-async-effect/use-async-effect'

type EffectFunction = (isMounted: () => boolean) => Promise<unknown> | unknown
type DestroyFunction = (result?: unknown) => void

export default function useAsyncOnUpdate(
  effect: EffectFunction,
  dependencies: DependencyList,
  destroy: DestroyFunction | null = null
) {
  const didMount = useRef(false)

  useAsyncEffect(
    async isMounted => {
      if (didMount.current) {
        return await effect(isMounted)
      } else {
        didMount.current = true
      }
    },
    dependencies,
    destroy
  )
}
